import { useHasPermissionQuery } from 'src/rbac/useHasPermission';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

export const useGetRibbonItemVisibilities = () => {
  const attestationsFeatureFlag = useIsFeatureVisibleToOrg('attestations');
  const policiesFeatureFlag = useIsFeatureVisibleToOrg('policy');

  const { hasPermission: hasApprovalPermission, loading: isLoadingApproval } =
    useHasPermissionQuery('read:change_request', undefined, true);
  const {
    hasPermission: hasAttestationPermission,
    loading: isLoadingAttestation,
  } = useHasPermissionQuery('read:attestation_record', undefined, true);
  const { hasPermission: hasActionPermission, loading: isLoadingAction } =
    useHasPermissionQuery('read:action', undefined, true);
  const { hasPermission: hasRiskPermission, loading: isLoadingRisk } =
    useHasPermissionQuery('read:risk', undefined, true);
  const {
    hasPermission: hasAssessmentPermission,
    loading: isLoadingAssessment,
  } = useHasPermissionQuery('read:assessment', undefined, true);
  const { hasPermission: hasIndicatorPermission, loading: isLoadingIndicator } =
    useHasPermissionQuery('read:indicator', undefined, true);
  const { hasPermission: hasPolicyPermission, loading: isLoadingPolicy } =
    useHasPermissionQuery('read:document', undefined, true);
  const { hasPermission: hasControlPermission, loading: isLoadingControl } =
    useHasPermissionQuery('read:control', undefined, true);
  const { hasPermission: hasIssuePermission, loading: isLoadingIssue } =
    useHasPermissionQuery('read:issue', undefined, true);

  const isLoading =
    isLoadingApproval ||
    isLoadingAttestation ||
    isLoadingAction ||
    isLoadingRisk ||
    isLoadingAssessment ||
    isLoadingIndicator ||
    isLoadingPolicy ||
    isLoadingControl ||
    isLoadingIssue;

  if (isLoading) {
    return {
      approvals: false,
      attestations: false,
      actions: false,
      risks: false,
      rcsa: false,
      indicators: false,
      policies: false,
      assessments: false,
      controls: false,
      issues: false,
    };
  }

  return {
    approvals: hasApprovalPermission,
    attestations: hasAttestationPermission && attestationsFeatureFlag,
    actions: hasActionPermission,
    risks: hasRiskPermission,
    rcsa: hasAssessmentPermission,
    indicators: hasIndicatorPermission,
    policies: hasPolicyPermission && policiesFeatureFlag,
    assessments: hasAssessmentPermission,
    controls: hasControlPermission,
    issues: hasIssuePermission,
  };
};
